import { z } from "zod";
import { contact } from "./contactFormValidation";

const addressSchema = z.object({
    branch_name: z.string().nullish(),
    city: z.string().nullish(),
    company_ledger_name: z.string().nullish(),
    country: z.string().nullish(),
    email: z.string().nullish(),
    gstin: z.string().nullish(),
    id: z.string().nullish(),
    landline_number: z.string().nullish(),
    address: z.string().nullish(),
    line1: z.string().nullish(),
    pincode: z.string().nullish(),
    state: z.string().nullish(),
    transport_name: z.string().nullish(),
    transport_delivery_station: z.string().nullish(),
}).nullish()

export const companyFormSchema = z.object({
  category: z.string().min(1, "Category is required"),
  ledger_name: z.string().min(1, "Ledger name is required"),
  legal_name: z.string().nullish(),
  pan_number: z.string().nullable().transform(val => val === "" ? null : val)
    .refine(val => val === null || /^[A-Z]{5}[0-9]{4}[A-Z]$/.test(val), "Invalid PAN number"),
  addresses: z.array(addressSchema).nullish(),
  email: z.string().nullish(),
  gstin: z.string().nullable().transform(val => val === "" ? null : val)
    .refine(val => val === null || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9]{1}[A-Z]{1}[0-9A-Z]{1}$/.test(val), "Invalid GSTIN"),
  inserted_at: z.date().nullish(),
  updated_at: z.date().nullish(),
  tags: z.array(z.string()).nullish(),
  members: z.array(z.string()).nullish(),
  type: z.string().min(1, "Type is required"),
  notes: z.string().nullish(),
  accounts: z.array(contact).nullish(),
  agent_ledger_name: z.string().nullish(),
  send_outstanding_to_accounts: z.union([
    z.array(z.string()), // For form submission - array of string IDs
    z.array(contact)     // For form initialization - array of contact objects
  ]).nullish(),
}).refine((data) => {
  return data.pan_number || data.gstin;
}, { message: "Either GSTIN or PAN number is required", path: ["gstin", "pan_number"] });

export type CompanyFormSchema = z.infer<typeof companyFormSchema>;